import {ServiceIdentifier} from "@infonova/framework/lib/service/types/ServiceIdentifier";
import {serviceIdentifier} from "@infonova/framework/lib/service/serviceIdentifier";
import {serviceRegistry} from "@infonova/framework/lib/service/configuration/serviceRegistry";
import {byConstructor} from "@infonova/framework/lib/service/factory/byConstructor";
import { SalesforceService } from "./external/SalesforceService";
import { SalesforceServiceImpl } from "./external/SalesforceServiceImpl";

import { IntegrationService } from "./integration-service/IntegrationService";
import { IntegrationServiceImpl } from "./integration-service/IntegrationServiceImpl";
import {AuthorizationProvider} from "@infonova/framework/lib/security/AuthorizationProvider";
import { SecurityConfiguration } from "@infonova/framework/lib/security/configuration/SecurityConfiguration";


export class ExternalServiceConfiguration {
    static readonly SalesforceService: ServiceIdentifier<SalesforceService> = serviceIdentifier<SalesforceService>("salesforceService");
    static readonly IntegrationService: ServiceIdentifier<IntegrationService> = serviceIdentifier<IntegrationService>("integrationService");

    static configure() {
        serviceRegistry().registerSingletonFactory(ExternalServiceConfiguration.SalesforceService, byConstructor<SalesforceService>(SalesforceServiceImpl))
        serviceRegistry().registerSingletonFactory(ExternalServiceConfiguration.IntegrationService, byConstructor<IntegrationService, AuthorizationProvider>(IntegrationServiceImpl, SecurityConfiguration.AuthorizationProvider))
    }

}